import Collection from '../../collection';
import Script from '../../model/refbooks/script';

export default Collection.extend( {
	endpoint: 'scripts/list?apiVersion=2.0&limit=1000000',
	responseAt: 'items',
    model: Script
} );


// WEBPACK FOOTER //
// ./src/js/collection/refbooks/scripts.js